export enum DashboardOptionsActiveChart {
  LEADS = "LEADS",
  APPROVE= "APPROVE"
}
